import { render, staticRenderFns } from "./CreateViolation.vue?vue&type=template&id=ff2abd3e&"
import script from "./CreateViolation.vue?vue&type=script&lang=js&"
export * from "./CreateViolation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports